import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Data } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { TrendMetricsFacade } from './trend-metrics.facade';
import { DashboardPageDefinition } from '../../dashboard.data';
import { DashboardVmState } from '../../domain/model/dashboard-vm.model';
import { TrendMetricsVm, TrendTileVm } from '../../domain/model/trend-metrics.model';

/** Trend metrics page: submitted, approved and funded volume over time, and four period tiles. */
@Component({
  selector: 'ifbp-trend-metrics',
  templateUrl: './trend-metrics.component.html',
  styleUrls: ['./trend-metrics.component.scss'],
  providers: [TrendMetricsFacade],
  standalone: false,
})
export class TrendMetricsComponent implements OnInit {
  page$: Observable<DashboardPageDefinition>;
  vm$: Observable<TrendMetricsVm>;
  readonly VmState = DashboardVmState;

  constructor(
    private readonly route: ActivatedRoute,
    private readonly facade: TrendMetricsFacade,
  ) {}

  ngOnInit(): void {
    this.page$ = this.route.data.pipe(map((data: Data) => data.dashboardPage as DashboardPageDefinition));
    this.vm$ = this.facade.vm$;
  }

  /** The four tiles are fixed and distinct; their titles are the stable key. */
  trackByTile(_index: number, tile: TrendTileVm): string {
    return tile.title;
  }
}
